import { FilterSelect } from "../components/FilterSelect.jsx";
// Reconstructed from the supplied production build; original component names were unavailable.
import { useAuth } from "../context/AuthContext.jsx";
import {
  AnimatePresence,
  ChevronDownIcon,
  CodeIcon,
  FunnelIcon,
  Grid3x3Icon,
  Helmet,
  ListIcon,
  React,
  RefreshCwIcon,
  SearchIcon,
  TagIcon,
  TrendingUpIcon,
  XIcon,
  jsxRuntime,
  motion,
  useNavigate,
} from "../vendor/runtime.js";
import { api } from "../api/client.js";
import { SERVER_URL } from "../config.js";
import { Navbar } from "../components/Navbar.jsx";
import { Button } from "../components/Button.jsx";
import { ProductCard } from "../components/ProductCard.jsx";
import { Footer } from "../components/Footer.jsx";
const ProductsPage = () => {
  const { currentUser: a } = useAuth(),
    n = useNavigate(),
    [i, l] = React.useState([]),
    [c, u] = React.useState(true),
    [m, f] = React.useState(null),
    [x, p] = React.useState("all"),
    [g, b] = React.useState("all"),
    [y, w] = React.useState([0, 1e5]),
    [N, T] = React.useState(""),
    [C, A] = React.useState(false),
    [O, M] = React.useState("newest"),
    [Y, R] = React.useState("all"),
    [U, W] = React.useState(false),
    [B, G] = React.useState([]),
    [te, ne] = React.useState("grid"),
    [de, Me] = React.useState(false),
    [Ce, we] = React.useState(8),
    [L, X] = React.useState(false),
    se = 8;
  (React.useEffect(() => {
    const _ = () => {
      Me(window.innerWidth < 768);
    };
    return (
      _(),
      window.addEventListener("resize", _),
      () => window.removeEventListener("resize", _)
    );
  }, []),
    React.useEffect(() => {
      const _ = () => {
        W(window.scrollY > 100);
      };
      return (window.addEventListener("scroll", _), () => window.removeEventListener("scroll", _));
    }, []),
    React.useEffect(() => {
      (async () => {
        try {
          u(true);
          const ye = (await api.get("/products")).data.map((Ge) => ({
            ...Ge,
            amount: typeof Ge.amount == "string" ? parseFloat(Ge.amount) : Ge.amount,
          }));
          (l(ye), G(ye.filter((Ge, He) => He % 3 === 0).map((Ge) => Ge.id)));
        } catch (ee) {
          (console.error("API Error:", ee),
            f(
              ee.response
                ? `Failed to fetch projects: ${ee.response.status} ${ee.response.statusText}`
                : "Network error when connecting to the server",
            ));
        } finally {
          u(false);
        }
      })();
    }, []),
    React.useEffect(() => {
      we(8);
    }, [x, g, N, O, Y, y]));
  const re = ["all", ...new Set(i.map((_) => _.category))],
    k = ["all", ...new Set(i.map((_) => _.language))],
    Q = SERVER_URL,
    ae = i.filter((_) => {
      const ee =
          _.title.toLowerCase().includes(N.toLowerCase()) ||
          _.description.toLowerCase().includes(N.toLowerCase()),
        ye = x === "all" || _.category === x,
        Ge = g === "all" || _.language === g,
        He = _.amount >= y[0] && _.amount <= y[1],
        ct = Y === "featured" ? B.includes(_.id) : true;
      return ee && ye && Ge && He && ct;
    }),
    J = [...ae].sort((_, ee) => {
      switch (O) {
        case "price-low":
          return _.amount - ee.amount;
        case "price-high":
          return ee.amount - _.amount;
        case "popular":
          return B.includes(ee.id) ? 1 : B.includes(_.id) ? -1 : (ee.id % 5) - (_.id % 5);
        case "newest":
        default:
          return ee.id - _.id;
      }
    }),
    ce = J.slice(0, Ce),
    je = Ce < J.length,
    he = () => {
      (X(true),
        setTimeout(() => {
          (we((_) => Math.min(_ + se, J.length)), X(false));
        }, 500));
    },
    ot = {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.08,
        },
      },
    },
    Re = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          type: "spring",
          stiffness: 260,
          damping: 20,
        },
      },
    },
    Mt = (_) => {
      n(`/products/${_}`);
    },
    Ss = () => {
      (p("all"), b("all"), w([0, 1e5]), T(""), M("newest"), R("all"), we(8));
    },
    Tt = (_) => {
      (p(_), R(_));
    };
  return c ? (
    <div className={"min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex flex-col"}>
      <Navbar />
      <Helmet>
        <title>{"Final Year Projects | Buy B.Tech, CSE, IT Projects Online – Codebruh"}</title>
        <meta
          name={"description"}
          content={
            "Explore and buy verified final year engineering projects for CSE, IT, ECE, EEE, and more. Each project includes source code, documentation, video demo, and AI-powered explanations."
          }
        />
        <meta
          name={"keywords"}
          content={
            "final year projects, BTech projects, engineering projects, CSE final year projects, ECE mini projects, IT project source code, academic project marketplace, buy student projects online, AI explained projects, project documentation, codebruh projects"
          }
        />
        <meta name={"robots"} content={"index, follow"} />
        <link rel={"icon"} type={"image/png"} href={"/Logo.webp"} />
        <meta property={"og:title"} content={"Final Year Projects Marketplace | Codebruh.in"} />
        <meta
          property={"og:description"}
          content={
            "Buy college projects online with source code, report, and AI explanation. Ideal for engineering students in CSE, IT, ECE, EEE, and more."
          }
        />
        <meta property={"og:url"} content={"https://codebruh.kestroinfotech.com/products"} />
        <meta property={"og:type"} content={"website"} />
        <meta property={"og:image"} content={"https://codebruh.kestroinfotech.com/banner.webp"} />
        <meta name={"author"} content={"Codebruh.in"} />
        <meta name={"viewport"} content={"width=device-width, initial-scale=1"} />
      </Helmet>
      <div className={"flex-grow flex items-center justify-center px-4"}>
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          className={"flex flex-col items-center"}
        >
          <div
            className={
              "w-12 h-12 sm:w-16 sm:h-16 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mb-3 sm:mb-4"
            }
          />
          <p className={"text-indigo-600 font-medium text-sm sm:text-base"}>
            {"Loading projects..."}
          </p>
        </motion.div>
      </div>
    </div>
  ) : m ? (
    <div className={"min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex flex-col"}>
      <Navbar />
      <div className={"flex-grow flex items-center justify-center p-4"}>
        <motion.div
          initial={{
            opacity: 0,
            y: 20,
          }}
          animate={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 0.5,
          }}
          className={
            "bg-white p-6 sm:p-8 rounded-xl sm:rounded-2xl shadow-xl max-w-md w-full text-center"
          }
        >
          <div
            className={
              "w-16 h-16 sm:w-20 sm:h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 relative"
            }
          >
            <XIcon className={"w-8 h-8 sm:w-10 sm:h-10 text-red-600"} strokeWidth={2.5} />
            <span
              className={
                "absolute -right-1 -top-1 w-6 h-6 sm:w-7 sm:h-7 bg-red-500 rounded-full flex items-center justify-center text-white text-sm sm:text-lg font-bold"
              }
            >
              {"!"}
            </span>
          </div>
          <h2 className={"text-xl sm:text-2xl font-bold text-slate-900 mb-2 sm:mb-3"}>
            {"Connection Error"}
          </h2>
          <p className={"text-slate-600 mb-6 sm:mb-8 text-sm sm:text-base"}>{m}</p>
          <Button
            variant={"primary"}
            className={
              "w-full py-2.5 sm:py-3 rounded-lg sm:rounded-xl shadow-lg shadow-indigo-200 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 text-sm sm:text-base"
            }
            onClick={() => window.location.reload()}
          >
            <RefreshCwIcon className={"w-4 h-4 mr-2"} />
            {" Try Again"}
          </Button>
        </motion.div>
      </div>
    </div>
  ) : (
    <div
      className={
        "min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 flex flex-col relative"
      }
    >
      <Navbar />
      <section
        className={"bg-slate-900 pt-24 sm:pt-32 lg:pt-40 relative overflow-hidden py-8 sm:py-12"}
      >
        <div
          className={
            "absolute inset-0 bg-gradient-to-r from-cyan-500/10 via-blue-500/10 to-purple-500/10"
          }
        />
        <div className={"absolute inset-0"}>
          <div
            className={
              "absolute top-0 left-1/4 w-48 h-48 sm:w-72 sm:h-72 bg-cyan-400/5 rounded-full blur-3xl"
            }
          />
          <div
            className={
              "absolute bottom-0 right-1/4 w-64 h-64 sm:w-96 sm:h-96 bg-blue-400/5 rounded-full blur-3xl"
            }
          />
        </div>
        <div className={"w-full  mx-auto px-4 sm:px-6 lg:px-8 relative"}>
          <div className={"w-full"}>
            <motion.div
              initial={{
                opacity: 0,
                y: 20,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              className={"text-center mb-6 sm:mb-8"}
            >
              <h1 className={"text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-2 sm:mb-3"}>
                {"Find Your Next "}
                <span
                  className={
                    "text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400"
                  }
                >
                  {"Project"}
                </span>
              </h1>
              <p className={"text-slate-300 text-base sm:text-lg"}>
                {"Browse "}
                {i.length}
                {"+ student-created projects and code templates"}
              </p>
            </motion.div>
            <motion.div
              initial={{
                opacity: 0,
                y: 20,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.2,
              }}
              className={
                "bg-slate-800/50 backdrop-blur-sm rounded-xl sm:rounded-2xl border border-slate-700/50 p-4 sm:p-6"
              }
            >
              <div className={"grid grid-cols-1 gap-3 sm:gap-4 lg:grid-cols-12 lg:items-end"}>
                <div className={"lg:col-span-5"}>
                  <label className={"block text-xs sm:text-sm font-medium text-slate-300 mb-2"}>
                    {"Search Projects"}
                  </label>
                  <div className={"relative"}>
                    <SearchIcon
                      className={
                        "absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-slate-400"
                      }
                    />
                    <input
                      type={"text"}
                      placeholder={"Project name, technology, category..."}
                      value={N}
                      onChange={(_) => T(_.target.value)}
                      className={
                        "w-full pl-9 sm:pl-11 pr-4 py-2.5 sm:py-3 bg-slate-700 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:border-transparent transition-all text-sm sm:text-base"
                      }
                    />
                  </div>
                </div>
                <div className={"lg:col-span-2"}>
                  <label className={"block text-xs sm:text-sm font-medium text-slate-300 mb-2"}>
                    {"Category"}
                  </label>
                  <FilterSelect label="Category"
                    value={x}
                    onChange={(_) => {
                      const ee = _.target.value;
                      (p(ee), R(ee));
                    }}
                    className={
                      "w-full px-3 py-2.5 sm:py-3 bg-slate-700 border border-slate-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:border-transparent text-sm sm:text-base"
                    }
                  >
                    <option value={"all"}>{"All Categories"}</option>
                    {re
                      .filter((_) => _ !== "all")
                      .map((_) => (
                        <option key={_} value={_}>
                          {_.charAt(0).toUpperCase() + _.slice(1)}
                        </option>
                      ))}
                  </FilterSelect>
                </div>
                <div className={"lg:col-span-2 hidden lg:block"}>
                  <label className={"block text-xs sm:text-sm font-medium text-slate-300 mb-2"}>
                    {"Language"}
                  </label>
                  <FilterSelect label="Language"
                    value={g}
                    onChange={(_) => b(_.target.value)}
                    className={
                      "w-full px-3 py-2.5 sm:py-3 bg-slate-700 border border-slate-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:border-transparent text-sm sm:text-base"
                    }
                  >
                    <option value={"all"}>{"All Languages"}</option>
                    {k
                      .filter((_) => _ !== "all")
                      .map((_) => (
                        <option key={_} value={_}>
                          {_}
                        </option>
                      ))}
                  </FilterSelect>
                </div>
                <div className={"lg:col-span-3"}>
                  <label className={"block text-xs sm:text-sm font-medium text-slate-300 mb-2"}>
                    {"Sort By"}
                  </label>
                  <div className={"flex gap-2"}>
                    <FilterSelect label="Sort by"
                      value={O}
                      onChange={(_) => M(_.target.value)}
                      className={
                        "flex-1 px-3 py-2.5 sm:py-3 bg-slate-700 border border-slate-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:border-transparent text-sm sm:text-base"
                      }
                    >
                                            <option value={"newest"}>{"Latest"}</option>
                      <option value={"price-low"}>{"Price ↑"}</option>
                      <option value={"price-high"}>{"Price ↓"}</option>
                      <option value={"popular"}>{"Popular"}</option>
                    </FilterSelect>
                    <button
                      onClick={() => A(!C)}
                      className={`px-3 sm:px-4 py-2.5 sm:py-3 rounded-lg transition-all ${C ? "bg-cyan-500 text-white" : "bg-slate-700 border border-slate-600 text-slate-300 hover:text-white"}`}
                    >
                      <FunnelIcon className={"w-4 h-4 sm:w-5 sm:h-5"} />
                    </button>
                  </div>
                </div>
                <div className={"lg:col-span-1 lg:hidden"}>
                  <button
                    onClick={() => A(!C)}
                    className={`w-full px-3 py-2.5 sm:py-3 rounded-lg transition-all ${C ? "bg-cyan-500 text-white" : "bg-slate-700 border border-slate-600 text-slate-300 hover:text-white"}`}
                  >
                    <FunnelIcon className={"w-4 h-4 sm:w-5 sm:h-5 mx-auto"} />
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      <AnimatePresence>
        {C && (
          <motion.div
            initial={{
              height: 0,
              opacity: 0,
            }}
            animate={{
              height: "auto",
              opacity: 1,
            }}
            exit={{
              height: 0,
              opacity: 0,
            }}
            transition={{
              duration: 0.3,
            }}
            className={"bg-white border-b border-slate-200 shadow-lg overflow-hidden"}
          >
            <div className={"w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6"}>
              <div
                className={
                  "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 sm:gap-4 lg:gap-6"
                }
              >
                <div className={"space-y-2"}>
                  <label
                    className={"flex items-center text-xs sm:text-sm font-semibold text-slate-700"}
                  >
                    <TagIcon className={"w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2 text-indigo-500"} />
                    {"Category"}
                  </label>
                  <FilterSelect label="Category"
                    value={x}
                    onChange={(_) => {
                      const ee = _.target.value;
                      (p(ee), R(ee));
                    }}
                    className={
                      "w-full px-3 py-2 sm:py-2.5 bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all text-sm"
                    }
                  >
                    <option value={"all"}>{"All Categories"}</option>
                    {re
                      .filter((_) => _ !== "all")
                      .map((_) => (
                        <option key={_} value={_}>
                          {_.charAt(0).toUpperCase() + _.slice(1)}
                        </option>
                      ))}
                  </FilterSelect>
                </div>
                <div className={"space-y-2"}>
                  <label
                    className={"flex items-center text-xs sm:text-sm font-semibold text-slate-700"}
                  >
                    <CodeIcon className={"w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2 text-indigo-500"} />
                    {"Language"}
                  </label>
                  <FilterSelect label="Language"
                    value={g}
                    onChange={(_) => b(_.target.value)}
                    className={
                      "w-full px-3 py-2 sm:py-2.5 bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all text-sm"
                    }
                  >
                    <option value={"all"}>{"All Languages"}</option>
                    {k
                      .filter((_) => _ !== "all")
                      .map((_) => (
                        <option key={_} value={_}>
                          {_}
                        </option>
                      ))}
                  </FilterSelect>
                </div>
                <div className={"space-y-2 sm:col-span-2 xl:col-span-2"}>
                  <label
                    className={"flex items-center text-xs sm:text-sm font-semibold text-slate-700"}
                  >
                    <span className={"w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2 text-indigo-500"}>
                      {"₹"}
                    </span>
                    {"Price Range"}
                  </label>
                  <div className={"flex flex-col sm:flex-row items-center gap-2 sm:gap-3"}>
                    <div className={"w-full sm:flex-1"}>
                      <input
                        type={"range"}
                        min={"0"}
                        max={"100000"}
                        step={"100"}
                        value={y[0]}
                        onChange={(_) => w([Math.min(parseInt(_.target.value), y[1]), y[1]])}
                        className={
                          "w-full h-2 bg-indigo-100 rounded-lg appearance-none cursor-pointer accent-indigo-600"
                        }
                      />
                    </div>
                    <div
                      className={
                        "flex items-center gap-1 sm:gap-2 text-xs sm:text-sm font-medium text-slate-600 whitespace-nowrap"
                      }
                    >
                      <span>
                        {"₹"}
                        {y[0]}
                      </span>
                      <span>{"-"}</span>
                      <span>
                        {"₹"}
                        {y[1]}
                      </span>
                    </div>
                    <div className={"w-full sm:flex-1"}>
                      <input
                        type={"range"}
                        min={"0"}
                        max={"100000"}
                        step={"100"}
                        value={y[1]}
                        onChange={(_) => w([y[0], Math.max(parseInt(_.target.value), y[0])])}
                        className={
                          "w-full h-2 bg-indigo-100 rounded-lg appearance-none cursor-pointer accent-indigo-600"
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className={"space-y-2"}>
                  <label
                    className={"flex items-center text-xs sm:text-sm font-semibold text-slate-700"}
                  >
                    <TrendingUpIcon
                      className={"w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2 text-indigo-500"}
                    />
                    {"Sort By"}
                  </label>
                  <FilterSelect label="Sort by"
                    value={O}
                    onChange={(_) => M(_.target.value)}
                    className={
                      "w-full px-3 py-2 sm:py-2.5 bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all text-sm"
                    }
                  >
                    <option value={"newest"}>{"Newest First"}</option>
                    <option value={"price-low"}>{"Price: Low to High"}</option>
                    <option value={"price-high"}>{"Price: High to Low"}</option>
                    <option value={"popular"}>{"Most Popular"}</option>
                  </FilterSelect>
                </div>
                <div className={"space-y-2"}>
                  <label
                    className={"flex items-center text-xs sm:text-sm font-semibold text-slate-700"}
                  >
                    <RefreshCwIcon
                      className={"w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2 text-indigo-500"}
                    />
                    {"Actions"}
                  </label>
                  <button
                    onClick={Ss}
                    className={
                      "w-full px-3 py-2 sm:py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg font-medium transition-all text-sm"
                    }
                  >
                    {"Reset All"}
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <div className={`bg-white border-b border-slate-200 ${de ? "" : "sticky top-0 z-40"}`}>
        <div className={"w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4"}>
          <div className={"flex items-center justify-between mb-2 sm:mb-3"}>
            <h3 className={"text-xs sm:text-sm font-semibold text-slate-700"}>
              {"Browse by Category"}
            </h3>
            <div className={"flex items-center gap-1 sm:gap-2"}>
              <button
                onClick={() => ne("grid")}
                className={`p-1.5 sm:p-2 rounded-lg transition-all ${te === "grid" ? "bg-indigo-100 text-indigo-600" : "text-slate-500 hover:bg-slate-100"}`}
              >
                <Grid3x3Icon className={"w-3 h-3 sm:w-4 sm:h-4"} />
              </button>
              <button
                onClick={() => ne("list")}
                className={`p-1.5 sm:p-2 rounded-lg transition-all ${te === "list" ? "bg-indigo-100 text-indigo-600" : "text-slate-500 hover:bg-slate-100"}`}
              >
                <ListIcon className={"w-3 h-3 sm:w-4 sm:h-4"} />
              </button>
            </div>
          </div>
          <div className={"flex gap-1.5 sm:gap-2 overflow-x-auto pb-2 scrollbar-hide"}>
            {["all", ...re.filter((_) => _ !== "all")].map((_) => (
              <button
                key={_}
                onClick={() => Tt(_)}
                className={`px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium whitespace-nowrap transition-all ${Y === _ ? "bg-indigo-600 text-white shadow-lg shadow-indigo-200" : "bg-slate-100 text-slate-700 hover:bg-slate-200"}`}
              >
                {_ === "all" ? "All Projects" : `${_.charAt(0).toUpperCase() + _.slice(1)}`}
              </button>
            ))}
          </div>
        </div>
      </div>
      <main className={"flex-grow w-full mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8"}>
        <div className={"w-full"}>
          <motion.div
            initial={{
              opacity: 0,
              y: 10,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            className={
              "flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 sm:mb-8 gap-3 sm:gap-4"
            }
          >
            <div className={"flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3"}>
              <h2 className={"text-xl sm:text-2xl font-bold text-slate-900"}>
                <span className={"text-indigo-600"}>{ae.length}</span>
                {" Projects Found"}
                {Ce < ae.length && (
                  <span className={"text-sm font-normal text-slate-500 ml-2"}>
                    {"(showing "}
                    {Ce}
                    {")"}
                  </span>
                )}
              </h2>
              {N && (
                <span
                  className={
                    "px-2 sm:px-3 py-1 bg-indigo-100 text-indigo-700 rounded-full text-xs sm:text-sm font-medium w-fit"
                  }
                >
                  {'for "'}
                  {N}
                  {'"'}
                </span>
              )}
            </div>
            <div className={"flex items-center gap-2 sm:gap-3 text-xs sm:text-sm text-slate-500"}>
              <div className={"flex items-center gap-1 sm:gap-2"}>
                <span>
                  {Math.floor(Math.random() * 1e3) + 500}
                  {" active students"}
                </span>
              </div>
              <div className={"w-px h-3 sm:h-4 bg-slate-300"} />
              <div className={"flex items-center gap-1 sm:gap-2"}>
                <span>
                  {"Updated "}
                  {Math.floor(Math.random() * 5) + 1}
                  {"h ago"}
                </span>
              </div>
            </div>
          </motion.div>
          {ce.length > 0 ? (
            <motion.div
              className={
                te === "grid"
                  ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-3 sm:gap-8"
                  : "space-y-3 sm:space-y-4"
              }
              variants={ot}
              initial={"hidden"}
              animate={"visible"}
            >
              {ce.map((_) =>
                te === "grid" ? (
                  <motion.div key={_.id} variants={Re}>
                    <ProductCard product={_} onView={Mt} ImageUrl={Q} featuredProducts={B} />
                  </motion.div>
                ) : (
                  <motion.div
                    key={_.id}
                    className={
                      "bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group border border-slate-100 flex items-center p-3 sm:p-4 gap-3 sm:gap-4"
                    }
                    variants={Re}
                  >
                    <div
                      className={
                        "w-16 h-16 sm:w-24 sm:h-24 rounded-lg sm:rounded-xl overflow-hidden flex-shrink-0 bg-gradient-to-br from-slate-100 to-slate-200"
                      }
                    >
                      <img
                        src={Q + _.image}
                        alt={_.title + " by codebruh final year project"}
                        className={"w-full h-full object-contain"}
                      />
                    </div>
                    <div className={"flex-1 min-w-0"}>
                      <div
                        className={
                          "flex flex-col sm:flex-row sm:items-start sm:justify-between mb-2 gap-2 sm:gap-4"
                        }
                      >
                        <div className={"flex-1 min-w-0"}>
                          <h3
                            className={
                              "text-sm sm:text-base font-semibold text-slate-900 group-hover:text-indigo-600 transition-colors line-clamp-1 mb-1 sm:mb-2"
                            }
                          >
                            {_.title}
                          </h3>
                          <p className={"text-slate-600 text-xs sm:text-sm line-clamp-2 mb-2"}>
                            {_.description}
                          </p>
                          <div className={"flex items-center gap-2 sm:gap-3"}>
                            <span
                              className={"text-xs bg-slate-100 text-slate-700 px-2 py-1 rounded-md"}
                            >
                              {_.category}
                            </span>
                            <span
                              className={
                                "text-xs bg-indigo-100 text-indigo-700 px-2 py-1 rounded-md"
                              }
                            >
                              {_.language}
                            </span>
                          </div>
                        </div>
                        <div
                          className={
                            "flex sm:flex-col items-center sm:items-end justify-between sm:justify-start gap-2 sm:gap-1 flex-shrink-0"
                          }
                        >
                          <div className={"text-lg sm:text-xl font-bold text-slate-900"}>
                            {"₹"}
                            {Number(_.amount).toFixed(0)}
                          </div>
                          <Button
                            variant={"primary"}
                            className={
                              "px-3 sm:px-4 py-1.5 sm:py-2 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white rounded-lg text-xs sm:text-sm font-medium"
                            }
                            onClick={() => Mt(_.id)}
                          >
                            {"View Details"}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                ),
              )}
            </motion.div>
          ) : (
            <motion.div
              initial={{
                opacity: 0,
                y: 20,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.5,
              }}
              className={"bg-white rounded-xl sm:rounded-2xl shadow-sm p-8 sm:p-12 text-center"}
            >
              <div
                className={
                  "w-20 h-20 sm:w-24 sm:h-24 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6"
                }
              >
                <SearchIcon className={"w-10 h-10 sm:w-12 sm:h-12 text-indigo-500"} />
              </div>
              <h3 className={"text-xl sm:text-2xl font-bold text-slate-900 mb-2 sm:mb-3"}>
                {"No projects found"}
              </h3>
              <p
                className={
                  "text-slate-600 mb-6 sm:mb-8 max-w-md mx-auto text-sm sm:text-base leading-relaxed"
                }
              >
                {
                  "We couldn't find any projects matching your search criteria. Try adjusting your filters or search terms."
                }
              </p>
              <div className={"flex flex-col sm:flex-row gap-2 sm:gap-3 justify-center"}>
                <Button
                  variant={"secondary"}
                  className={
                    "px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg sm:rounded-xl border-2 border-indigo-200 text-indigo-700 hover:bg-cyan-600 transition-all font-medium text-sm sm:text-base"
                  }
                  onClick={Ss}
                >
                  {"Reset Filters"}
                </Button>
                <Button
                  variant={"primary"}
                  className={
                    "px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg sm:rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-medium text-sm sm:text-base"
                  }
                  onClick={() => (window.location.href = "#max-widget")}
                >
                  {"Custom project"}
                </Button>
              </div>
            </motion.div>
          )}
          {je && (
            <motion.div
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              transition={{
                delay: 0.5,
              }}
              className={"mt-8 sm:mt-12 text-center"}
            >
              <button
                onClick={he}
                disabled={L}
                className={
                  "inline-flex items-center px-6 sm:px-8 py-3 sm:py-4 bg-white border-2 border-slate-200 rounded-lg sm:rounded-xl text-slate-700 font-medium hover:bg-slate-50 hover:border-slate-300 transition-all shadow-sm hover:shadow-md text-sm sm:text-base disabled:opacity-50 disabled:cursor-not-allowed"
                }
              >
                {L ? (
                  <jsxRuntime.Fragment>
                    <div
                      className={
                        "w-4 h-4 sm:w-5 sm:h-5 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin mr-2"
                      }
                    />
                    {"Loading..."}
                  </jsxRuntime.Fragment>
                ) : (
                  <jsxRuntime.Fragment>
                    {"Load More Projects"}
                    <ChevronDownIcon className={"ml-2 w-4 h-4 sm:w-5 sm:h-5"} />
                    <span
                      className={
                        "ml-2 px-2 py-0.5 bg-indigo-100 text-indigo-700 rounded-full text-xs font-bold"
                      }
                    >
                      {"+"}
                      {Math.min(se, J.length - Ce)}
                    </span>
                  </jsxRuntime.Fragment>
                )}
              </button>
              <p className={"mt-2 text-xs sm:text-sm text-slate-500"}>
                {"Showing "}
                {Ce}
                {" of "}
                {J.length}
                {" projects"}
              </p>
            </motion.div>
          )}
          {!je && J.length > 8 && (
            <motion.div
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              className={"mt-8 sm:mt-12 text-center"}
            >
              <div
                className={
                  "inline-flex items-center px-4 py-2 bg-green-50 border border-green-200 rounded-lg text-green-700 text-sm font-medium"
                }
              >
                <div className={"w-2 h-2 bg-green-400 rounded-full mr-2"} />
                {"All projects loaded ("}
                {J.length}
                {" total)"}
              </div>
            </motion.div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};
export { ProductsPage };
